import { PolicyEnrollment } from './policy-enrollment.model';

export interface EnrollmentsResponse {
  enrolledPolicies: PolicyEnrollment[];
}
